import {DeviceGridViewActions, DeviceGridViewActionTypes} from '../actions/device-grid-view.actions';
import {AddFloorIdPayload, AddGroupIdPayload, HoverDevicePayload, RemoveFloorIdPayload, RemoveGroupIdPayload} from '../models/device-grid';
import {Condition} from '../../afb-api/enums/condition.enum';

export interface State {
  hoveredDeviceUuid: string | null;
  hasEmptyConditionFilter: boolean;
  hasEmptyGroupFilter: boolean;
  hasEmptyFloorFilter: boolean;
  selectedConditions: Condition[];
  selectedGroupIds: string[];
  selectedFloorIds: string[];
}

export const initialState: State = {
  hoveredDeviceUuid: null,
  hasEmptyConditionFilter: true,
  hasEmptyGroupFilter: true,
  hasEmptyFloorFilter: true,
  selectedConditions: [],
  selectedGroupIds: [],
  selectedFloorIds: []
};

export function reducer(state = initialState, action: DeviceGridViewActions): State {
  switch (action.type) {

    case DeviceGridViewActionTypes.HoverDeviceSuccess: {
      const hoverDevicePayload: HoverDevicePayload = action.payload;

      return {
        ...state,
        hoveredDeviceUuid: hoverDevicePayload.deviceUuid
      };
    }

    case DeviceGridViewActionTypes.HoverOutSuccess: {
      return {
        ...state,
        hoveredDeviceUuid: null
      };
    }

    case DeviceGridViewActionTypes.AddCondition: {
      const addedCondition: Condition = action.payload;
      const addedSelectedConditions: Condition[] = [...state.selectedConditions, addedCondition];

      return {
        ...state,
        selectedConditions: addedSelectedConditions,
        hasEmptyConditionFilter: addedSelectedConditions.length < 1
      };
    }

    case DeviceGridViewActionTypes.RemoveCondition: {
      const removedCondition: Condition = action.payload;
      const removedSelectedConditions: Condition[] = state.selectedConditions.filter(
        (selectedCondition: Condition) => selectedCondition !== removedCondition
      );

      return {
        ...state,
        selectedConditions: removedSelectedConditions,
        hasEmptyConditionFilter: removedSelectedConditions.length < 1
      };
    }

    case DeviceGridViewActionTypes.DeselectConditionSuccess: {
      return {
        ...state,
        selectedConditions: [],
        hasEmptyConditionFilter: true
      };
    }

    case DeviceGridViewActionTypes.AddGroupId: {
      const {groupId}: AddGroupIdPayload = action.payload;
      const addedSelectedGroupIds: string[] = [...state.selectedGroupIds, groupId];

      return {
        ...state,
        selectedGroupIds: addedSelectedGroupIds,
        hasEmptyGroupFilter: addedSelectedGroupIds.length < 1
      };
    }

    case DeviceGridViewActionTypes.RemoveGroupId: {
      const {groupId}: RemoveGroupIdPayload = action.payload;
      const removeSelectedGroupIds: string[] = state.selectedGroupIds.filter((selectedGroupId: string) => selectedGroupId !== groupId);

      return {
        ...state,
        selectedGroupIds: removeSelectedGroupIds,
        hasEmptyGroupFilter: removeSelectedGroupIds.length < 1
      }
    }

    case DeviceGridViewActionTypes.DeselectGroupIdSuccess: {
      return {
        ...state,
        selectedGroupIds: [],
        hasEmptyGroupFilter: true
      };
    }

    case DeviceGridViewActionTypes.AddFloorId: {
      const {floorId}: AddFloorIdPayload = action.payload;
      const addedSelectedFloorIds: string[] = [...state.selectedFloorIds, floorId];

      return {
        ...state,
        selectedFloorIds: addedSelectedFloorIds,
        hasEmptyFloorFilter: addedSelectedFloorIds.length < 1
      };
    }

    case DeviceGridViewActionTypes.RemoveFloorId: {
      const {floorId}: RemoveFloorIdPayload = action.payload;
      const removedSelectedFloorIds: string[] = state.selectedFloorIds.filter((selectedFloorId: string) => selectedFloorId !== floorId);

      return {
        ...state,
        selectedFloorIds: removedSelectedFloorIds,
        hasEmptyFloorFilter: removedSelectedFloorIds.length < 1
      };
    }

    case DeviceGridViewActionTypes.DeselectFloorIdSuccess: {
      return {
        ...state,
        selectedFloorIds: [],
        hasEmptyFloorFilter: true
      };
    }

    default:
      return state;
  }
}

export const hoveredDeviceUuid = (state: State) => state.hoveredDeviceUuid;
export const hasEmptyConditionFilter = (state: State) => state.hasEmptyConditionFilter;
export const hasEmptyGroupFilter = (state: State) => state.hasEmptyGroupFilter;
export const hasEmptyFloorFilter = (state: State) => state.hasEmptyFloorFilter;
export const selectedConditions = (state: State) => state.selectedConditions;
export const selectedGroupIds = (state: State) => state.selectedGroupIds;
export const selectedFloorIds = (state: State) => state.selectedFloorIds;
